import { PARTICIPANT_PARAM_MAP, ParticipantEnum } from '@/constants/common';

export const getParticipantByParam = (
  participantParam?: string
): ParticipantEnum | undefined => {
  if (!participantParam) return;
  return PARTICIPANT_PARAM_MAP[participantParam.trim().toLowerCase()];
};
